import { combineReducers } from "redux";

import ui from "./uiReducer";
import lessons from "./lessonsReducer";
import { USER_SIGNOUT_SUCCESS } from "./../actions/authActions";
import notifications from "./notificationsReducer";
import auth from "./authReducer";
const appReducer = combineReducers({
  ui,
  notifications,
  lessons,
  auth
});

const rootReducer = (state, action) => {
  if (action.type === USER_SIGNOUT_SUCCESS) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js